import type { BusinessCriticality } from '../types';

interface BusinessCriticalityLabelProps {
  criticality: BusinessCriticality | null | undefined;
}

const CRITICALITY_LABELS: Record<BusinessCriticality, string> = {
  Critical: 'Critical',
  High: 'High',
  Medium: 'Medium',
  Low: 'Low',
};

const CRITICALITY_COLORS: Record<BusinessCriticality, string> = {
  Critical: 'text-[#314158]',
  High: 'text-[#314158]',
  Medium: 'text-[#314158]',
  Low: 'text-[#314158]',
};

export function BusinessCriticalityLabel({ criticality }: BusinessCriticalityLabelProps) {
  if (!criticality) {
    return (
      <span className="font-['Inter'] font-normal text-sm leading-5 text-[#71717A]">
        —
      </span>
    );
  }

  const label = CRITICALITY_LABELS[criticality];
  const colorClass = CRITICALITY_COLORS[criticality];

  return (
    <span className={`font-['Inter'] font-normal text-sm leading-5 ${colorClass}`}>
      {label}
    </span>
  );
}
